import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    ColumnDirective, ColumnsDirective,
    GridComponent, Grid, Inject, Page, Sort, Filter, Resize,
    Toolbar, ExcelExport, PdfExport, ColumnChooser
} from '@syncfusion/ej2-react-grids';
import { Aggregate, ForeignKey, getForeignData, Group, AggregateColumnDirective, AggregateColumnsDirective, AggregateDirective, AggregatesDirective } from '@syncfusion/ej2-react-grids';
import HttpClient from './../../../services/httpClient';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import { Dropdown, Select } from 'semantic-ui-react'
import { Button } from 'semantic-ui-react'
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import { useTranslation } from "react-i18next";
import { finishLoading, setTitle, startLoading } from "./../../../store/actions/uiAction";
import { logReportService } from "./../../../services/logReportService";
import ComboHotelSala from "./../../../components/combo-hotel-sala/combo-hotel-sala";
import ComboUsuariosSala from "./../../../components/combo-usuarios/combo-usuarios";
import { MultiSelectComponent, CheckBoxSelection, Inject as InjectDrop } from '@syncfusion/ej2-react-dropdowns';




const PRProduction = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [dateStart, setDateStart] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(new Date());
    const [rowData, setRowData] = useState([]);
    const [NameSala, setNameSala] = useState([]);
    const [NameHotel, setNameHotel] = useState([]);
    const [NamePrograma, setNamePrograma] = useState([]);
    const user = useSelector(state => state.auth.currentUser);
    const { idSaleRoom, idHotel, idUser } = useSelector(state => state.user.param);
    const [countriesData, setCountriesData] = useState([]);
    const [colaboradoresData, setColaboradoresData] = useState([]);
    const [programasData, setProgramasData] = useState([]);
    let grid = null;

    let mulObjcountries = [];

    let mulObjColaboradores = [];

    let mulObjProgramas = [];




    const getData = (url, data) => {
        dispatch(startLoading());
        return new Promise((resolve, eject) => {
            HttpClient.get(url, data)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    eject(error);
                })
        });
    }

    const getOptionData = (url) => {
        return new Promise((resolve, eject) => {
            getData(url).then((response) => {
                if (response.status === 200) {
                    let obj = response.data;
                    let res = [];
                    for (let i in obj) {
                        let item = { Code: obj[i].id, Name: obj[i].name };
                        res.push(item)
                    }

                    resolve(res);
                }
            })
        })

    }

    const getCountriesData = () => {
        getOptionData('/catalog/paises')
            .then((response) => {
                setCountriesData(response);
            })
    }

    const getColaboradoresData = () => {
        getOptionData('/catalog/colaboradores-mkt')
            .then((response) => {
                setColaboradoresData(response);
            })
    }

    const getProgramasData = () => {
        getOptionData('/catalog/programas')
            .then((response) => {
                setProgramasData(response);
            })
    }

    const toolbarOptions = ['ColumnChooser'];
    const checkFields = { text: 'Name', value: 'Code' };
    const options = [
        { key: 'excel', icon: 'edit', text: 'Export to excel', value: 'excel' },
        { key: 'pdf', icon: 'delete', text: 'Export to pdf', value: 'pdf' },
    ]

    const onChangeDateStart = (event, data) => setDateStart(data.value);
    const onChangeDateEnd = (event, data) => setDateEnd(data.value);

    const getDataReport = (url) => {
        dispatch(startLoading());
        return new Promise((resolve, eject) => {
            HttpClient.get(url)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    eject(error);
                })
        });
    }

    const handleViewButton = () => {
        getManifestReport();
    }

    const getManifestReport = () => {

        const date1 = dateStart.toISOString().slice(0, 10).replace(/-/g, '');
        const date2 = dateEnd.toISOString().slice(0, 10).replace(/-/g, '');

        const idPais = (mulObjcountries != null && mulObjcountries.value.length > 0) ? mulObjcountries.value.map(String).toString() : "0";

        const idColaborador = (mulObjColaboradores != null && mulObjColaboradores.value.length > 0) ? mulObjColaboradores.value.map(String).toString() : "0";

        const programas = (mulObjProgramas != null && mulObjProgramas.value.length > 0) ? mulObjProgramas.value.map(String).toString() : "0";



        getDataReport(`/catalog/getNameSalavtaId/${idSaleRoom}`).then((response) => {
            if (response.status === 200) {
                setNameSala(response.data);
            }
        })

        getDataReport(`/catalog/getNameHotelId/${idHotel}`).then((response) => {
            if (response.status === 200) {
                setNameHotel(response.data);
            }
        })

        getDataReport(`/catalog/getNameProgramaId/${programas}`).then((response) => {
            if (response.status === 200) {
                setNamePrograma(response.data);
            }
        })

        getDataReport(`/reports/pr-production-by-country/${date1}/${date2}/${idSaleRoom}/${idHotel}/${idPais}/${idColaborador}/${programas}`).then((response) => {
            if (response.status === 200) {
                setRowData(response.data);
                logReportService.add('PR-Production Report', user);
            }
        })
    }

    // Reporte
    const handleButtonOption = (opt) => {
        if (grid && opt.target.innerText === 'Export to excel') {
            export2Excel();
        } else {
            if (grid && opt.target.innerText === 'Export to pdf') {
                grid.pdfExport();
            }
        }
    }

    const groupOptions = {
        columns: ['colaborador'],
        showDropArea: false,
        captionTemplate: '${key} - ${count} items'
    };

    const excelQueryCellInfo = (args) => {
        if (args.column.field === 'TotalVolumen') {
            args.style = { numFmt: '"$"#,##0.00' };
        }
    };

    const excelHeaderQueryCellInfo = (args) => {
        args.style = { backColor: '#3F97BF', fontColor: '#000000', bold: true };
    };

    const export2Excel = () => {
        if (!grid || !grid.dataSource || grid.dataSource.length === 0) {
            console.warn('No hay datos para exportar');
            return;
        }

        const date1 = dateStart.toDateString();
        const date2 = dateEnd.toDateString();

        const excelExportProperties = {
            fileName: t('menusidebar.label.pr-production-by-country') + ".xlsx",
            hierarchyExportMode: 'All',
            theme: {
                caption: { fontName: 'Calibri', fontColor: '#666666', fontSize: 13 },
                header: { fontName: 'Calibri', fontColor: '#000000', backColor: '#3F97BF', fontSize: 13 },
                record: { fontName: 'Calibri', fontSize: 11 }
            },
            header: {
                headerRows: 6,
                rows: [
                    { cells: [{ colSpan: 10, value: "LVC KCS " + t('menusidebar.label.pr-production-by-country'), style: { fontColor: '#000000', fontSize: 16, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 10, value: "SALES ROOM: " + (NameSala?.name || ''), style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 10, value: "HOTELS: " + (NameHotel?.name || ''), style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 10, value: "PROGRAMS: " + (NamePrograma?.[0]?.name || ''), style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 10, value: date1 + " - " + date2, style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                ]
            }
        }

        try {
            grid.excelExport(excelExportProperties);
        } catch (error) {
            console.error('Error al exportar a Excel:', error);
        }
    }

const exportExcelEfficiencyFromAPI = () => {
        const base_url = process.env.REACT_APP_URL_API_PATH;
        const date1 = dateStart.toISOString().slice(0, 10).replace(/-/g, '');
        const date2 = dateEnd.toISOString().slice(0, 10).replace(/-/g, '');

        const idPais = (mulObjcountries != null && mulObjcountries.value.length > 0) ? mulObjcountries.value.map(String).toString() : "0";

        const idColaborador = (mulObjColaboradores != null && mulObjColaboradores.value.length > 0) ? mulObjColaboradores.value.map(String).toString() : "0";

        const programas = (mulObjProgramas != null && mulObjProgramas.value.length > 0) ? mulObjProgramas.value.map(String).toString() : "0";

        var download_excel_url = `${base_url}/reports/pr-production-by-country-xls/${date1}/${date2}/${idSaleRoom}/${idHotel}/${idPais}/${idColaborador}/${programas}`;
        //console.log(download_excel_url);
        window.open(download_excel_url, '_parent');
    }

    const handleExport2Excel = () => {
        if (grid) {
            export2Excel();
        }
    }

    const handleToolbarClick = (args) => {
        if (grid && args.item.id === 'grid_excelexport') {
            export2Excel();
        } else {
            if (grid && args.item.id === 'grid_pdfexport') {
                grid.pdfExport();
            }
        }
    }

    const dataBound = () => {
        if (grid) {
            grid.autoFitColumns();
        }
    }

    // Función personalizada para calcular el total de penetración
    const customAggregate = (data) => {
        if (!data || !Array.isArray(data.result)) {
            return 0;
        }
        
        let totalShows = 0;
        let totalParejas = 0;
        
        data.result.forEach(item => {
            totalShows += item.shows || 0;
            totalParejas += item.parejasDisponibles || 0;
        });
        
        const penetracion = totalParejas > 0 ? (totalShows / totalParejas) : 0;
        return penetracion;
    }

     function customAggregateFnPenetracionFK(data) {
        console.log('customAggregateFnPenetracionFK data:', data);
        
        // Manejar diferentes estructuras de datos de Syncfusion
        let items = [];
        
        if (data && data.result && Array.isArray(data.result)) {
            items = data.result;
        } else if (data && Array.isArray(data)) {
            items = data;
        } else if (data && data.items && Array.isArray(data.items)) {
            items = data.items;
        } else if (data && data.aggregate && data.aggregate.result) {
            items = data.aggregate.result;
        }
        
        if (items.length === 0) {
            console.log('No items found, returning 0');
            return 0;
        }
        
        var totalShows = 0;
        var totalParejas = 0;
        
        // Iterar sobre los elementos del grupo actual
        for (var i = 0; i < items.length; i++) {
            totalShows += (items[i]['shows'] || 0);
            totalParejas += (items[i]['parejasDisponibles'] || 0);
        }
        
        console.log('Total Shows:', totalShows, 'Total Parejas:', totalParejas);
        
        let penetracion = 0;
        if (totalParejas > 0) {
            penetracion = totalShows / totalParejas;
        }
        
        console.log('Penetración calculada:', penetracion);
        
        // Retornar el valor calculado
        return penetracion;
    }

    // Fin Reporte

    useEffect(() => {
        getCountriesData();
        getColaboradoresData();
        getProgramasData();
        dispatch(setTitle(t('menusidebar.label.pr-production-by-country')));
    }, []);



    return (

        <div className="container-fluid px-2 px-md-3">
            <div className="card shadow-sm mb-3">
                <div className="card-body">
                
                    <ComboHotelSala />
                    
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-4 form-group">
                            <label className="font-weight-bold"><i className="fas fa-users mr-1"></i>Colaboradores:</label>
                            <MultiSelectComponent id="colaboradores" ref={(scope) => { mulObjColaboradores = scope; }} dataSource={colaboradoresData}
                                fields={checkFields} placeholder="Seleccionar colaboradores" mode="CheckBox" showSelectAll={true}
                                showDropDownIcon={true} filterBarPlaceholder="Buscar colaborador" popupHeight="350px" value={[]}>
                                <InjectDrop services={[CheckBoxSelection]} />
                            </MultiSelectComponent>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 form-group">
                            <label className="font-weight-bold"><i className="fas fa-list mr-1"></i>Programas:</label>
                            <MultiSelectComponent id="programas" ref={(scope) => { mulObjProgramas = scope; }} dataSource={programasData}
                                fields={checkFields} placeholder="Seleccionar programas" mode="CheckBox" showSelectAll={true}
                                showDropDownIcon={true} filterBarPlaceholder="Buscar programa" popupHeight="350px" value={[]}>
                                <InjectDrop services={[CheckBoxSelection]} />
                            </MultiSelectComponent>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 form-group">
                            <label className="font-weight-bold"><i className="fas fa-globe mr-1"></i>Países:</label>
                            <MultiSelectComponent id="countries" ref={(scope) => { mulObjcountries = scope; }} dataSource={countriesData}
                                fields={checkFields} placeholder="Seleccionar países" mode="CheckBox" showSelectAll={true}
                                showDropDownIcon={true} filterBarPlaceholder="Buscar país" popupHeight="350px" value={[]}>
                                <InjectDrop services={[CheckBoxSelection]} />
                            </MultiSelectComponent>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 form-group">
                            <label className="font-weight-bold"><i className="fas fa-calendar-alt mr-1"></i>Fecha inicio:</label>
                            <SemanticDatepicker className="w-100" name="dateStart" value={dateStart} onChange={onChangeDateStart} />
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 form-group">
                            <label className="font-weight-bold"><i className="fas fa-calendar-check mr-1"></i>Fecha fin:</label>
                            <SemanticDatepicker className="w-100" name="dateEnd" value={dateEnd} onChange={onChangeDateEnd} />
                        </div>
                        <div className="col-12 col-md-4 col-lg-6 form-group d-flex align-items-end">
                            <div className="btn-group w-100" role="group">
                                <Button primary fluid onClick={handleViewButton} className="d-flex align-items-center justify-content-center">
                                    <i className="fas fa-eye mr-2"></i>
                                    <span className="d-none d-sm-inline">Ver Reporte</span>
                                    <span className="d-inline d-sm-none">Ver</span>
                                </Button>
                                <Button positive fluid onClick={exportExcelEfficiencyFromAPI} className="d-flex align-items-center justify-content-center">
                                    <i className="fas fa-file-excel mr-2"></i>
                                    <span className="d-none d-sm-inline">Exportar Excel</span>
                                    <span className="d-inline d-sm-none">Excel</span>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="card shadow-sm">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <GridComponent id="grid" height='auto' width='100%'
                    dataSource={rowData}
                    allowSorting={true}
                    allowResizing={true}
                    allowExcelExport={true}
                    allowPdfExport={false}
                    excelQueryCellInfo={excelQueryCellInfo}
                    excelHeaderQueryCellInfo={excelHeaderQueryCellInfo}
                    groupSettings={groupOptions}
                    allowGrouping={true}
                    ref={g => grid = g}
                >
                    <Inject services={[Sort, Toolbar, Resize, ExcelExport, PdfExport, Group, Aggregate, ColumnChooser]} />
                    <ColumnsDirective>
                        <ColumnDirective field='colaborador' headerText="Colaborador" width='180' minWidth='150' visible={false} textAlign="Left" />
                        <ColumnDirective field='country' headerText="País" width='100' minWidth='90' textAlign="Left" />
                        <ColumnDirective field='infoNoInvitado' headerText="Info no invitado" width='90' minWidth='80' textAlign="Right" />
                        <ColumnDirective field='invitado' headerText="Invitado" width='80' minWidth='70' textAlign="Right" />
                        <ColumnDirective field='noDisponible' headerText="No disponible" width='90' minWidth='80' textAlign="Right" />
                        <ColumnDirective field='porContactar' headerText="Por contactar" width='90' minWidth='80' textAlign="Right" />
                        <ColumnDirective field='shows' headerText="Shows" width='70' minWidth='60' textAlign="Right" />
                        <ColumnDirective field='total' headerText="Total" width='70' minWidth='60' textAlign="Right" />
                        <ColumnDirective field='parejasDisponibles' headerText="Parejas disp." width='90' minWidth='80' textAlign="Right" />
                        <ColumnDirective field='penetracion' headerText="% Penetración" width='95' minWidth='85' textAlign="Right" format="P2" />
                        <ColumnDirective field='ventas' headerText="Ventas" width='70' minWidth='60' textAlign="Right" />
                        <ColumnDirective field='TotalVolumen' headerText="Total Volumen" width='100' minWidth='90' textAlign="Right" format="C2" />
                    </ColumnsDirective>
                    <AggregatesDirective>
                        <AggregateDirective>
                            <AggregateColumnsDirective>
                                <AggregateColumnDirective field='infoNoInvitado' type='Sum' />
                                <AggregateColumnDirective field='invitado' type='Sum' />
                                <AggregateColumnDirective field='noDisponible' type='Sum' />
                                <AggregateColumnDirective field='porContactar' type='Sum' />
                                <AggregateColumnDirective field='shows' type='Sum' />
                                <AggregateColumnDirective field='total' type='Sum' />
                                <AggregateColumnDirective field='parejasDisponibles' type='Sum' />
                                <AggregateColumnDirective field='penetracion' type='Custom' format='P2' customAggregate={customAggregateFnPenetracionFK} />
                                <AggregateColumnDirective field='ventas' type='Sum' />
                                <AggregateColumnDirective field='TotalVolumen' type='Sum' format="C2" />
                            </AggregateColumnsDirective>
                        </AggregateDirective>
                    </AggregatesDirective>

                </GridComponent>
                    </div>
                </div>
            </div>
            
            <style>{`
                @media (max-width: 768px) {
                    .e-grid .e-gridheader {
                        font-size: 11px;
                    }
                    .e-grid .e-gridcontent {
                        font-size: 10px;
                    }
                    .card-title {
                        font-size: 1rem;
                    }
                    .e-grid .e-headercelldiv {
                        padding: 3px;
                    }
                }
                @media (max-width: 576px) {
                    .e-grid .e-headercelldiv {
                        padding: 2px;
                        font-size: 10px;
                    }
                    .e-grid .e-rowcell {
                        padding: 2px;
                        font-size: 9px;
                    }
                }
                @media (min-width: 1024px) and (max-width: 1440px) {
                    .e-grid .e-gridheader {
                        font-size: 12px;
                    }
                    .e-grid .e-gridcontent {
                        font-size: 11px;
                    }
                    .e-grid .e-headercelldiv {
                        padding: 5px 3px;
                    }
                    .e-grid .e-rowcell {
                        padding: 5px 3px;
                    }
                }
                .e-grid {
                    border: none;
                    font-size: 12px;
                }
                .e-grid .e-groupdroparea {
                    display: none;
                }
                .e-grid .e-grouptopleftcell {
                    width: 30px !important;
                }
                .e-grid .e-recordplusexpand,
                .e-grid .e-recordpluscollapse {
                    width: 20px !important;
                    height: 20px !important;
                }
                .e-grid .e-groupcaption {
                    font-weight: 600;
                    background-color: #f5f5f5;
                    font-size: 13px;
                }
                .e-grid .e-summarycell {
                    font-weight: 600;
                    background-color: #f0f8ff;
                }
                .btn-group .ui.button {
                    border-radius: 0;
                }
                .btn-group .ui.button:first-child {
                    border-radius: 4px 0 0 4px;
                }
                .btn-group .ui.button:last-child {
                    border-radius: 0 4px 4px 0;
                }
                .table-responsive {
                    overflow-x: auto;
                    -webkit-overflow-scrolling: touch;
                }
            `}</style>
        </div>
    );
}

export default PRProduction;
